import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import DatePickerRange from '../components/DatePickerRange';
import FlatButton from 'material-ui/FlatButton';
import NavigationArrowDropDownCircle from 'material-ui/svg-icons/navigation/arrow-drop-down-circle';
import SocialNotifications from 'material-ui/svg-icons/social/notifications'
import TextField from 'material-ui/TextField';
import GridList from 'material-ui/GridList';

const styles = {
	container:{
		height:50,
		lineHeight:'2.5',
		width:'89%',
	},
	titleRow:{
		display:'flex',
		text:{
			color:'#fff',
			fontSize:'20px',
			fontWeight:'300',
			flex:9,
		},
		close:{
			color:'red',
	    	opacity:'0.8',
			flex:1,
			lineHeight:'3.6'
		}
	},
	buttonsRow:{
		display:'flex',
		backgroundColor:'#fff',
	},
	statusRow:{
		display:'flex',
		backgroundColor:'#fff',
		height:50,
		marginTop:15,
		lineHeight:'50px',
		title:{
			backgroundColor:'rgb(92, 95, 103)',
			width:130,
			textAlign:'center',
		},
		status:{
			color:'black',
			paddingLeft:'1%',
			fontSize:'15px',
			iconStyle:{
				color:'blue',
				height:19,
				width:19,
				marginRight:7,
				verticalAlign:'text-bottom',
			},
		}
	},
	tweaksRow:{
		display:'flex',
		backgroundColor:'#fff',
		height:120,
		marginTop:15,
		lineHeight:'50px',
		title:{
			backgroundColor:'rgb(92, 95, 103)',
			width:130,
			textAlign:'center',
			fontSize:23
		},
		etfs:{
			color:'black',
			paddingLeft:'1%',
			fontSize:'15px',
			width:"40%",
			doubleInput:{
				// display: 'flex',
		    // flexDirection: 'row wrap',
				name:{
					flex:1,
					textTransform:"uppercase",
				},
				percent:{
					flex:1,
					marginLeft:'9%',
				},
			},
			plus:{
				fontSize:23,
			},
		}
	},
	button:{
		margin: 12,
		marginTop:'1.6%',
	    flex:1,
        lineHeight: '31px',
	    height: 35,
	    borderStyle:'solid',
	    borderWidth:1,
	    borderRadius:2,
	    run:{
	    	borderColor:'#47b927',
	    	color:'#47b927',
	    },
	    stop:{
	    	borderColor:'red',
	    	color:'red',
	    	opacity:'0.6',
	    },
	},
	buttonLabel:{
	    textTransform:'none',

	},
	backtestStatus:{
		fontStyle: 'italic',
	},
	DropDownMenu:{
		verticalAlign:'top',
		marginTop:'0.2%',
		flex:1,
		paddingRight:30,
		paddingLeft:15,
	}
}
export default class BacktestModule extends React.Component {

	constructor(props) {
		super(props)

		this.bakctestStatusInterval = null;

		this.state = {resolution:0, etfTools:[],}
	}

	componentDidMount(){
		console.log("backtest mount")
		this.startStatusInterval()
	}

	componentWillUnmount(){
		clearInterval(this.bakctestStatusInterval)
	}

	startStatusInterval(){

		const self = this
		self.props.BuildStore.backtestStatus()
		this.bakctestStatusInterval = setInterval(function(){
			self.props.BuildStore.backtestStatus()
		},5000)
	}

	runBacktest(){
		// console.log("runing")
		this.props.BuildStore.runBacktest(this.state.etfTools)
		// console.log(this.props.BuildStore.backtestResponse)
	}

	findSectorByName = (sectors, name) => {

		var foundSector = false
		for (var i = 0; i < sectors.length; i++) {
			if(sectors[i].name == name){
				return sectors[i]
			}
		}
	}

	breakBacktest(){
		this.props.BuildStore.breakBacktest()
	}

	selectDate = (val) => {

		this.props.BuildStore.date = (val.minDate.getMonth()+1) + "/" + val.minDate.getDate() + "/" + val.minDate.getFullYear()
		this.props.BuildStore.endDate = (val.maxDate.getMonth()+1) + "/" + val.maxDate.getDate() + "/" + val.maxDate.getFullYear()
		console.log(val.minDate.getDate())
		this.validateEtfs(false)
	}


	etfNameChanged = (event) => {
		const e = event;
		e.preventDefault();
		let index = e.target.id.split("__")[0]
		let name = e.target.value
		this.updateEtfTool(index, 'name', name)
		if(name.length == 0){
			let etfsArr = this.state.etfTools
			etfsArr.splice(index, 1)
			this.setState({etfTools:etfsArr})
		}
		if (name.length > 1){
			this.validateEtfs([name])
		}
	}

	etfPercentChanged = (event) => {

			const e = event;
			e.preventDefault();
			var index = e.target.id.split("__")[0]
			this.updateEtfTool(index, 'percent', e.target.value)

	}

	updateEtfTool = (index, key, value) => {

		var etfs = this.state.etfTools
		etfs[index][key] = value
		this.props.BuildStore.etfTools = etfs
		this.setState({etfTools:etfs})

	}

	pushEtf = () =>{
		let etfs = this.state.etfTools
		etfs.push({name:"",percent:"",status:false})
		this.setState({etfTools:etfs})
		console.log("new etfTools: ", this.state.etfTools)
	}

	// false = all
	validateEtfs = (specific_etfs) => {
		const self = this
		if (!specific_etfs){
			specific_etfs = []
			for (var i = 0; i < this.state.etfTools.length; i++) {
				specific_etfs.push(this.state.etfTools[i].name)
			}
		}
		let etfs = specific_etfs
		let timestamp = this.props.BuildStore.date // maybe need conversion
		this.props.BuildStore.validateEtfs(etfs, timestamp).then(function(res){
				self.onEtfsResponse(res)
		})

	}

	onEtfsResponse = (res) => {

		let etfs = this.state.etfTools
		etfs.forEach(function(tool){
				console.log('validating ' + tool.name)
				if (typeof res[tool.name] !== "undefined"){

					tool.status = res[tool.name]
				}
		})
		this.setState({etfTools:etfs})
		console.log("new etfs status ", this.state.etfTools);
	}

	selectRes = (event, index, value) => {
		// console.log( value)
		this.props.BuildStore.resolution = value
		this.setState({resolution:value})
	}
	render = () => {

		var etfInputs = this.state.etfTools.map(function(etf, index){
			let doubleStyle = {
				display: 'flex',
				flexDirection: 'row wrap',
				color: 'gray'
			}
			let inputStyle = {
				textTransform:"uppercase",
				color:"red",
				fontWeight:"inherit",
			}
			// console.log(etf)
			if (etf.status){
				inputStyle.color = 'green'
				inputStyle.fontWeight="900"
			}

			return(
				<div key={index} style={doubleStyle}>
					<TextField style={styles.tweaksRow.etfs.doubleInput.name} id={index + "__name"} onChange={this.etfNameChanged.bind(this)}
					value={etf.name} hintText="etf" inputStyle={inputStyle}>
					</TextField>
					<TextField style={styles.tweaksRow.etfs.doubleInput.percent}  id={index + "__percent"} onChange={this.etfPercentChanged.bind(this)}
					value={etf.percent} hintText="%" inputStyle={inputStyle}>
					</TextField>
				</div>)
		}.bind(this))
		let dDIconNode = <NavigationArrowDropDownCircle/>
		const {BuildStore} = this.props
		const onCloseFn = this.props.closeBacktest
		var btMessage = this.props.backtestStatusMsg == 'Backtest running' ? (<span><b>Backtest is in process!</b> You will be notified by email once the backtest is complete</span>) : this.props.backtestStatusMsg
		return(

			<div className="backtest-module" style={styles.container}>
				<div style={styles.titleRow}>
					<span style={styles.titleRow.text}>Backtest your strategy</span>
					<a onClick={onCloseFn} style={styles.titleRow.close} className="pull-right" >
						x Close Backtest
					</a>
				</div>
				{
				// <button onClick={this.props.closeBacktest} className="pull-right clean_btn close_btn"><img src={require("../../img/x_icon.png")}/></button>
				}
				<div style={styles.buttonsRow}>
					<DatePickerRange outerStyle={{flex:2, paddingLeft:15}} onChange={this.selectDate.bind(this)}/>
			        <DropDownMenu iconButton={dDIconNode}
			        value={this.state.resolution} style={styles.DropDownMenu}  onChange={this.selectRes}>
			          <MenuItem value={0} primaryText="Regular" />
			          <MenuItem value={1} primaryText="Fast" />
			          <MenuItem value={2} primaryText="Faster" />
		        	</DropDownMenu>
					<FlatButton labelStyle={styles.buttonLabel} style={{...styles.button, ...styles.button.run}} label="Run Backtest" onClick={this.runBacktest.bind(this)}></FlatButton>
					<FlatButton labelStyle={styles.buttonLabel} style={{...styles.button, ...styles.button.stop}} disabled={this.props.backtestStatusCode == 0} label="Stop Backtest" onClick={this.breakBacktest.bind(this)}></FlatButton>
				</div>
				<div style={styles.statusRow}>
					<span style={styles.statusRow.title}> Current Status </span>
					<span style={styles.statusRow.status}>
						<SocialNotifications style={styles.statusRow.status.iconStyle}/>
						{btMessage}
						{
						//{this.props.backtestStatusMsg}
						//His father was a merchant from Massachusetts and his mother, Kinoʻoleoliliha, was a Hawaiian noble.  !!!
						}

					</span>
				</div>
				<div style={styles.tweaksRow}>
					<span style={styles.tweaksRow.title}> Backtest<br/>Tweaks </span>
					<span style={styles.tweaksRow.etfs}>

						<GridList
								cellHeight={30}
								cols={3}
								padding={12}
							>
							{etfInputs}
							<div key="plus"><a style={styles.tweaksRow.etfs.plus} onClick={this.pushEtf}>+</a></div>
						</GridList>
							{
							//{this.props.backtestStatusMsg}
							//His father was a merchant from Massachusetts and his mother, Kinoʻoleoliliha, was a Hawaiian noble.  !!!
							}

					</span>
				</div>

				{
					// /<RaisedButton style={styles.button} label="run backtest" onClick={this.runBacktest.bind(this)}></RaisedButton>
				}
				{//this.props.backtestResponse
				// <h4>Current Status</h4>
				// <div style={styles.backtestStatus}>
				// 	{this.props.backtestStatusMsg}
				// </div>
				}

			</div>
		);

	}
}



// WEBPACK FOOTER //
// ./src/js/components/BacktestModule.js